import Store from '@mjcloud/redux';
import { IReduce } from '@mjcloud/redux';
import GridEditCellBaseReduce from '../gridedit-cell-base/reduce';
import { IEditableComplexCellState, IEditableComplexCellInitialStateParams } from './typings';

class GridEditCellReduce extends GridEditCellBaseReduce
  implements IReduce<IEditableComplexCellState> {
  initialState(
    store: Store<IEditableComplexCellState>,
    params: IEditableComplexCellInitialStateParams,
  ) {
    const state: IEditableComplexCellState = this.__initialState(params);
    return state;
  }
}

export default new GridEditCellReduce();
